/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Card1Inputs */

const en_dr_room_card1 = /** @type {(inputs: Dr_Room_Card1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DP 30% charged automatically via virtual account`)
};

const id_dr_room_card1 = /** @type {(inputs: Dr_Room_Card1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DP 30% dipotong otomatis lewat virtual account`)
};

/**
* | output |
* | --- |
* | "DP 30% charged automatically via virtual account" |
*
* @param {Dr_Room_Card1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_card1 = /** @type {((inputs?: Dr_Room_Card1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Card1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_card1(inputs)
	return en_dr_room_card1(inputs)
});